import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  parts: [],
  selectedNla: null,
};

const nlaReceivingSlice = createSlice({
  name: "nlaReceiving",
  initialState,
  reducers: {
    setParts(state, action) {
      state.parts = action.payload;
    },
    clearParts(state) {
      state.parts = [];
    },
    setSelectedNLA (state , action){
      state.selectedNla = action.payload
    },
    clearSelectedNLA (state){
      state.selectedNla = null;
    }
  },
});

export const { setParts, clearParts , setSelectedNLA , clearSelectedNLA} = nlaReceivingSlice.actions;

export default nlaReceivingSlice.reducer;
